import { CoursesModal } from './core/courses-modal';

import { fetchAndStoreTeacherTabColors } from '../../../pages/catalog/assets/js/utils/colors';

document.addEventListener('DOMContentLoaded', () => {
   
  fetchAndStoreTeacherTabColors();
});

export default CoursesModal; 